export default "__VITE_ASSET__fc1997a1__"